// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S7my","right":"styles_right__53jwl"};